export const CookieConsentEvent = Object.freeze({
    BannerShown: 'cookie-banner-shown',
    Accepted: 'cookie-consent-accepted',
    Rejected: 'cookie-consent-rejected',
    Partial: 'cookie-consent-partial',
});

export const ChoiceSource = Object.freeze({
    Banner: 'banner',
    Preferences: 'preferences',
});

const optionalCookieLevels = ['functionality', 'tracking', 'targeting'];

const choiceSourceByWidgetEvent = {
    cc_noticeBannerOkOrAgreePressed: ChoiceSource.Banner,
    cc_noticeBannerRejectPressed: ChoiceSource.Banner,
    cc_preferencesCenterSavePressed: ChoiceSource.Preferences,
};

const consentEventName = (acceptedLevelCount) => {
    if (acceptedLevelCount === optionalCookieLevels.length) {
        return CookieConsentEvent.Accepted;
    }

    if (acceptedLevelCount === 0) {
        return CookieConsentEvent.Rejected;
    }

    return CookieConsentEvent.Partial;
};

// Sends the visitor's cookie banner choice to Umami. The widget also saves
// consent for an undecided visitor on every page load, so a save is only
// tracked when one of the choice buttons came before it.
export const registerCookieConsentTracking = (target = document, getTracker = () => window.umami) => {
    let pendingChoiceSource = null;

    const track = (eventName, eventData) => {
        const tracker = getTracker();

        if (tracker && typeof tracker.track === 'function') {
            tracker.track(eventName, eventData);
        }
    };

    target.addEventListener('cc_noticeBannerShown', () => track(CookieConsentEvent.BannerShown));

    Object.entries(choiceSourceByWidgetEvent).forEach(([widgetEventName, source]) => {
        target.addEventListener(widgetEventName, () => {
            pendingChoiceSource = source;
        });
    });

    target.addEventListener('cc_userConsentSaved', (event) => {
        const source = pendingChoiceSource;
        const acceptedLevels = event.details;

        pendingChoiceSource = null;

        if (source === null || typeof acceptedLevels !== 'object' || acceptedLevels === null) {
            return;
        }

        const levelData = Object.fromEntries(
            optionalCookieLevels.map((level) => [level, acceptedLevels[level] === true]),
        );
        const acceptedLevelCount = Object.values(levelData).filter(Boolean).length;

        track(consentEventName(acceptedLevelCount), { source, ...levelData });
    });
};
